import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ApiProvider from '../Api/ApiProvider';

@Component({})
export default class LoginComponent extends Vue {
    @Prop()
    siteTags: string;

    email: string = '';
    submitted: boolean = false;
    loading: boolean = false;
    error: string = null;
    emailExists: boolean = true;

    async recover() {
        this.loading = true;
        let siteTags = this.siteTags.split(",");

        let clients = ApiProvider.getUserClients(siteTags);

        const promises = clients.map(async (client) => {
            let emailExists = await client.getEmailExists(this.email);

            if (emailExists) {
                let success = await client.postRecovery(this.email, this.locale);

                if (success) {
                    this.loading = false;
                    this.emailExists = true;
                    this.submitted = true;
                } else {
                    this.loading = false;
                    this.emailExists = true;
                    this.error = 'Internal Server Error'
                }
            }
        });

        try {
            await Promise.all(promises);

            this.loading = false;

            if (!this.submitted) {
                this.emailExists = false;
            }
        }
        catch (e) {
            this.error = (e as Error).message;
            console.log(e);
        }

        this.loading = false;
    }

    get locale() {
        let locale = $.cookie("locale");

        if (!locale) {
            locale = "en";
        }

        return locale;
    }
}
Vue.component('password-recovery', LoginComponent);